import { connectStepper } from "../util/redux";
import Emotion from "../components/emotion";

export default connectStepper(Emotion);
